import { Element } from "@craftjs/core";
import Container from "components/general/Container";
import Section from "components/general/Section";
import { Box, Card, Image, Typography } from "components/ui";
import React from "react";
import alwaysHungry from "../../../assets/cover-values/always-hungry.png";
import fastFix from "../../../assets/cover-values/fast-fix.png";
import ownIt from "../../../assets/cover-values/own-it.png";
import weNotI from "../../../assets/cover-values/we-not-i.png";
import { PageText } from "./PageText";

export const CoreValuesTitle = ({ ...props }) => {
	return <div>{props.children}</div>;
};

export const PageCoreValues = ({ background }: { background?: string }) => {
	let coreValues = [
		{
			title: "Always Hungry",
			description: "Keep challenging the status quo, as we can ALWAYS do better and good is the enemy of GREAT! Strive to make things better, set new benchmarks and be a better person than you were yesterday.",
			icon: alwaysHungry,
		},
		{ title: "Fast Fix", description: "Actions always speak louder than words. Taking action right NOW to get results whilst always raising the bar is what keeps us ahead of the game.", icon: fastFix },
		{ title: "We, Not I", description: "Your success is always a consequence of how well you work with your environment and those around you. Great leaders are always humble and work hard to set others up for success.", icon: weNotI },
		{ title: "Own It", description: "Stop pointing out and start pointing in. Be responsible for your actions, your job, your life and your word by seeing things through to completion. Exceed expectations.", icon: ownIt },
	];
	return (
		<Box bg={background || undefined}>
			<Container>
				<Section bg={background || "transparent"} gap={48}>
					<Element id="core-values-title" data-cy="core-values-title-container" is={CoreValuesTitle}>
						<PageText text="Core Values" fontSize={36} data-cy="core-values-text" />
					</Element>
					<Box
						flexDirection="column"
						sx={{
							"@md": {
								flexDirection: "row",
							},
						}}
						gap={20}
					>
						{coreValues.map((value, index) => {
							return (
								<Card bg="$neutral50" gap={12} borderRadius={12} padding={26} flex={1} key={index}>
									<Box mb={6}>
										<Image source={value.icon} sx={{ width: "$full" }} />
									</Box>
									<Typography weight="bold">{value.title}</Typography>
									<Typography.ParagraphSmall sx={{ color: "$neutral600" }}>{value.description}</Typography.ParagraphSmall>
								</Card>
							);
						})}
					</Box>
					{/* <Text>Core Values</Text> */}
				</Section>
			</Container>
		</Box>
		// <PageContainer background={"white"} padding={20}>
		// 	<div {...props}>
		// 		<Element id="listing-title" is={DocumentListTitle} data-cy="document-list-title"></Element>
		// 		<Element canvas id="document-drop-location" is={DocumentListLocation} data-cy="document-drop-location"></Element>
		// 	</div>
		// </PageContainer>
	);
};
